export const defaultGlobalContent = {
  navbar: {
    logo: "/assets/images/logo.png",
    ctaLabel: "Nous contacter",
  },
  contact: {
    email: "contact@fatihoune.com",
    whatsapp: "+212649040912",
    whatsappLabel: "WhatsApp",
    address: "Nahda N1 Comp Rabat, Maroc",
  },
  footer: {
    kicker: "Fatihoune S.A.R.L",
    title: "Un projet à structurer ou une mission à lancer ?",
    description:
      "Formation, conseil, assistance et services opérationnels pour accompagner les particuliers, entreprises et institutions avec méthode.",
    primaryCta: "Parler à un conseiller",
    secondaryCta: "Voir les documents",
    newsletterText:
      "Recevez les nouvelles offres, documents et actualités Fatihoune.",
  },
  socialLinks: [
    { label: "LinkedIn", url: "" },
    { label: "Facebook", url: "" },
    { label: "YouTube", url: "https://www.youtube.com/@fatihounefatihoune3984" },
  ],
};

export const defaultPages = {
  home: {
    title: "Accueil",
    seo: {
      title: "Fatihoune - Formation, conseil et assistance",
      description:
        "Fatihoune accompagne entreprises, institutions et particuliers avec des services de formation, conseil et assistance.",
    },
    sections: {
      hero: {
        kicker: "Cabinet de formation, conseil et assistance",
        title: "Formations, conseil et assistance pour vos projets terrain.",
        description:
          "Fatihoune aide entreprises, institutions et particuliers à cadrer leurs besoins, renforcer les équipes et lancer les bonnes actions.",
        primaryCta: "Recevoir une proposition",
        secondaryCta: "Voir nos habilitations",
        image: "/assets/images/hero3.jpg",
        stats: [
          { value: "2017", label: "année de création" },
          { value: "3", label: "pays d'intervention" },
          { value: "+5K", label: "clients accompagnés" },
          { value: "60", label: "collaborateurs" },
        ],
      },
      proof: {
        kicker: "Signaux de confiance",
        title: "Des éléments concrets pour décider avec sérénité.",
        description:
          "Avant de solliciter une mission, vos équipes peuvent vérifier nos documents, comprendre notre méthode et choisir le bon canal de contact.",
        primaryCta: "Consulter les documents",
        secondaryCta: "Qualifier ma demande",
        items: [
          {
            label: "Habilitations",
            title: "Documents consultables",
            text: "Les agréments et pièces publiques sont accessibles avant le premier échange.",
          },
          {
            label: "Méthode",
            title: "Cadrage avant proposition",
            text: "Chaque demande est orientée selon le besoin, le pays, le délai et le profil du client.",
          },
          {
            label: "Terrain",
            title: "Interventions multi-pays",
            text: "Une présence entre le Maroc, la Côte d'Ivoire et des relais internationaux.",
          },
        ],
      },
      highlights: {
        kicker: "Nos domaines d'intervention",
        title: "Des expertises organisées autour de vos enjeux prioritaires.",
        cta: "Recevoir une proposition",
      },
      achievements: {
        kicker: "Réalisations",
        title: "Des missions concrètes menées avec méthode.",
        description:
          "Quelques exemples de projets structurés pour renforcer les équipes, cadrer les priorités et produire des résultats vérifiables.",
        cta: "Parler d'un projet similaire",
      },
      about: {
        kicker: "Pourquoi nous choisir",
        title: "Une approche directe, documentée et orientée terrain.",
      },
    },
  },
  about: {
    title: "À propos",
    seo: {
      title: "À propos de Fatihoune",
      description:
        "Découvrez la mission, les objectifs, les valeurs et les atouts de Fatihoune.",
    },
    sections: {
      hero: {
        title: "Qui nous sommes ?",
        description:
          "Créée en 2017, FATIHOUNE Sarl apporte une assistance pluridisciplinaire pour améliorer les compétences des entreprises et des administrations.",
      },
      stats: [
        { value: "3", label: "Pays" },
        { value: "+5K", label: "Clients" },
        { value: "60", label: "Collaborateurs" },
      ],
      blocks: [
        {
          title: "NOTRE MISSION",
          text: "FATIHOUNE Sarl a pour mission d'apporter une assistance pluridisciplinaire dans l’amélioration des compétences des entreprises et des administrations dans toute l’Afrique.",
          image: "/assets/images/mission.jpg",
          imageAlt: "Mission Fatihoune",
        },
        {
          title: "NOS OBJECTIFS",
          items: [
            "Contribuer au développement des entreprises par le renforcement de leur performance et de leur compétitivité",
            "Offrir aux clients des prestations de qualité et adaptées à leurs besoins",
            "Développer des solutions formations sur mesure et fournir une assistance personnalisée",
            "Aider à l’alignement du système d’information à la stratégie de l’entreprise et en faire un autre levier de la productivité et de la croissance",
            "Éclairer les entreprises et leurs dirigeants dans la prise de décision grâce à nos activités de conseils",
          ],
          image: "/assets/images/objectif.jpg",
          imageAlt: "Objectifs Fatihoune",
        },
        {
          title: "NOS VALEURS",
          items: [
            "Agir efficacement et durablement",
            "Proposer une qualité de service tout en tenant compte du coût de la prestation et de son délai d’exécution",
            "Conformer le cabinet aux standards internationaux tout en multipliant les opportunités d’emploi et d’avancement.",
          ],
          image: "/assets/images/value.jpg",
          imageAlt: "Valeurs Fatihoune",
        },
        {
          title: "NOS ATOUTS",
          items: [
            "Réseau d’experts de haut niveau",
            "Qualité des interventions et alignement sur les standards internationaux",
            "Matériel et expertise adaptés aux besoins des clients.",
          ],
          image: "/assets/images/atout.jpg",
          imageAlt: "Atouts Fatihoune",
        },
      ],
    },
  },
  contact: {
    title: "Contact",
    seo: {
      title: "Contact Fatihoune",
      description:
        "Contactez Fatihoune pour une demande de formation, conseil, partenariat, documents ou assistance.",
    },
    sections: {
      hero: {
        kicker: "Contact Fatihoune",
        title: "Parlons de votre projet avec précision.",
        description:
          "Formation, conseil, assistance ou partenariat: envoyez-nous les informations clés et nous orientons votre demande vers le bon interlocuteur.",
        image: "/assets/images/rabat.jpg",
        noteLabel: "Base opérationnelle",
        noteValue: "Rabat, Maroc",
      },
      formAside: {
        kicker: "Bien orienter la demande",
        title: "Quelques informations suffisent pour démarrer.",
        description:
          "Le formulaire prépare une demande structurée pour identifier le bon service, le niveau d'urgence et le contexte d'intervention.",
      },
    },
  },
  documents: {
    title: "Documents",
    seo: {
      title: "Documents et agréments Fatihoune",
      description:
        "Retrouvez les documents publics, habilitations et références de Fatihoune.",
    },
    sections: {
      hero: {
        kicker: "Documents & agréments",
        title: "Des documents publics pour vérifier notre sérieux.",
        description:
          "Retrouvez les habilitations et références utiles avant de lancer une discussion avec notre équipe.",
      },
      cta: {
        kicker: "Besoin d'un autre document ?",
        title: "Notre équipe peut vous orienter vers le bon interlocuteur.",
        button: "Qualifier ma demande",
      },
    },
  },
  realisations: {
    title: "Réalisations",
    seo: {
      title: "Réalisations et missions Fatihoune",
      description:
        "Consultez des exemples de missions menées par Fatihoune en formation, conseil et assistance.",
    },
    sections: {
      hero: {
        kicker: "Toutes les missions",
        title: "Des réalisations vérifiables pour comprendre notre manière d'intervenir.",
        description:
          "Chaque mission présente le contexte, l'approche et les résultats obtenus afin de vous aider à vous projeter avant le premier échange.",
      },
      cta: {
        kicker: "Vous avez un besoin similaire ?",
        title: "Parlons de votre mission et des résultats attendus.",
        button: "Qualifier ma demande",
      },
    },
  },
};

export const defaultDocuments = [
  {
    title: "ABE",
    description: "Document de référence disponible au téléchargement.",
    href: "/assets/documents/abe.pdf",
    type: "PDF",
  },
  {
    title: "Habilitation FDED 2026",
    description: "Habilitation et éléments administratifs associés.",
    href: "/assets/documents/habilitation-fded-2026.pdf",
    type: "PDF",
  },
  {
    title: "Habilitation GERME Fatihoune",
    description: "Document d'habilitation GERME pour consultation.",
    href: "/assets/documents/habilitation-germe-fatihoune.pdf",
    type: "PDF",
  },
];

export const defaultAchievements = [
  {
    slug: "renforcement-capacites-equipes-terrain",
    title: "Renforcement des capacités d'équipes terrain",
    clientName: "Institution publique",
    category: "Formation",
    country: "Maroc",
    year: "2025",
    description:
      "Conception et animation d'un parcours de formation adapté aux contraintes opérationnelles des participants.",
    result:
      "Des équipes mieux outillées pour appliquer les méthodes sur le terrain et partager des pratiques communes.",
    imageUrl: "/assets/images/mission.jpg",
    metrics: [
      { value: "120+", label: "participants" },
      { value: "4", label: "modules" },
    ],
  },
  {
    slug: "cadrage-strategique-organisation-croissance",
    title: "Cadrage stratégique pour une organisation en croissance",
    clientName: "Entreprise privée",
    category: "Conseil",
    country: "Côte d'Ivoire",
    year: "2025",
    description:
      "Diagnostic des priorités, clarification des chantiers critiques et formalisation d'une feuille de route actionnable.",
    result:
      "Une direction plus lisible, des responsabilités mieux réparties et une base claire pour décider.",
    imageUrl: "/assets/images/objectif.jpg",
    metrics: [
      { value: "6", label: "chantiers priorisés" },
      { value: "30 j", label: "de cadrage" },
    ],
  },
  {
    slug: "assistance-operationnelle-mission-multi-acteurs",
    title: "Assistance opérationnelle à une mission multi-acteurs",
    clientName: "Partenaire international",
    category: "Assistance",
    country: "Afrique de l'Ouest",
    year: "2024",
    description:
      "Coordination des besoins, préparation documentaire et accompagnement des échanges entre parties prenantes.",
    result:
      "Une mission mieux structurée, avec des livrables exploitables et un suivi partagé.",
    imageUrl: "/assets/images/atout.jpg",
    metrics: [
      { value: "3", label: "pays concernés" },
      { value: "1", label: "cadre commun" },
    ],
  },
];
